export class FormBuilderEditorConfigurationModel {
    private _data = {
        toolbar: [
            'heading', '|', 'bold', 'italic', 'underline', '|', 'bulletedList', 'numberedList', '|', 'imageupload'
        ],
        // Uncomment the following lines to enable simple upload adapter
        // Documentation: https://ckeditor.com/docs/ckeditor5/latest/features/image-upload/simple-upload-adapter.html
        // simpleUpload: {
        //     uploadUrl: 'http://example.com',
        //     withCredentials: false,
        //     headers: {
        //         'X-CSRF-TOKEN': 'CSRF-Token',
        //         Authorization: 'Bearer <JSON Web Token>'
        //     }
        // }
    };

    get data(): any {
        return this._data;
    }
}
